import { Link } from 'react-router-dom';
import { isPanelModuleEnabled } from '../../../_config/countries/panel-modules.config';
import { LABEL_MENU } from './label-menu.constant';

export const OPTION_MENU = [
	{
		key: 'home-main',
		label: <Link to={`/`}>{LABEL_MENU.HOME['home-main']}</Link>,
		icon: null,
	},

	{
		key: 'pharmacy-main',
		label: LABEL_MENU.PHARMACY['pharmacy-main'],
		icon: null,
		children: [
			{
				key: 'pharmacy-locals',
				label: <Link to="/v2/pharmacy-locals/list">{LABEL_MENU.PHARMACY['pharmacy-locals']}</Link>,
				icon: null,
			},
			{
				key: 'pharmacy-locals-admin',
				label: <Link to="/v2/admin-pharmacy-locals/list">{LABEL_MENU.PHARMACY['pharmacy-locals-admin']}</Link>,
				icon: null,
			},

			{
				key: 'pharmacy-letters',
				label: <Link to="/v2/letters">{LABEL_MENU.PHARMACY['pharmacy-letters']}</Link>,
				icon: null,
			},
			{
				key: 'pharmacy-letters-admin',
				label: <Link to="/v2/admin-letters">{LABEL_MENU.PHARMACY['pharmacy-letters-admin']}</Link>,
				icon: null,
			},
		],
	},
	{
		key: 'followup-main',
		label: LABEL_MENU.FOLLOWUP['followup-main'],
		icon: null,
		children: [
			{
				key: 'followup-reports-admin',
				label: <Link to="/v2/admin-report">{LABEL_MENU.FOLLOWUP['followup-reports-admin']}</Link>,
				icon: null,
			},
			{
				key: 'followup-reports',
				label: <Link to="/v2/report">{LABEL_MENU.FOLLOWUP['followup-reports']}</Link>,
				icon: null,
			},
			...(isPanelModuleEnabled('reserve')
				? [
						{
							key: 'followup-request-admin',
							label: (
								<Link to={`/v2/admin-reserve/list?status=100&page=1`}>
									{LABEL_MENU.FOLLOWUP['followup-request-admin']}
								</Link>
							),
							icon: null,
						},
						{
							key: 'followup-request',
							label: (
								<Link to={`/v2/reserve/list?status=100&page=1`}>{LABEL_MENU.FOLLOWUP['followup-request']}</Link>
							),
							icon: null,
						},
				  ]
				: []),
			...(isPanelModuleEnabled('quotation')
				? [
						{
							key: 'followup-quotation',
							label: (
								<Link to={`/quotation?status=100&page=1`}>{LABEL_MENU.FOLLOWUP['followup-quotation']}</Link>
							),
							icon: null,
						},
						{
							key: 'followup-quotation-admin',
							label: (
								<Link to={`/admin-quotation?status=requested&page=1`}>
									{LABEL_MENU.FOLLOWUP['followup-quotation-admin']}
								</Link>
							),
							icon: null,
						},
				  ]
				: []),
			...(isPanelModuleEnabled('preorder')
				? [
						{
							key: 'followup-preorder',
							label: (
								<Link to={`/preorder?status=PAYMENT_PENDING&page=1`}>
									{LABEL_MENU.FOLLOWUP['followup-preorder']}
								</Link>
							),
							icon: null,
						},
				  ]
				: []),
			{
				key: 'followup-purchase-orders',
				label: <Link to={`/v2/tracking/list?status=all&page=1`}>{LABEL_MENU.FOLLOWUP['followup-purchase-orders']}</Link>,
				icon: null,
			},
			{
				key: 'followup-purchase-orders-admin',
				label: <Link to={`/v2/admin-tracking/list?status=all&page=1`}>{LABEL_MENU.FOLLOWUP['followup-purchase-orders']}</Link>,
				icon: null,
			},
			{
				key: 'followup-claims',
				label: <Link to={`/v2/claims/list?status=open&page=1`}>{LABEL_MENU.FOLLOWUP['followup-claims']}</Link>,
				icon: null,
			},
			{
				key: 'followup-claims-admin',
				label: <Link to={`/v2/admin-claims/list?status=open&page=1`}>{LABEL_MENU.FOLLOWUP['followup-claims-admin']}</Link>,
				icon: null,
			},
		],
	},
	{
		key: 'products-main',
		label: LABEL_MENU.PRODUCTS['products-main'],
		icon: null,
		children: [
			{
				key: 'products-migration',
				label: <Link to="/migration2">{LABEL_MENU.PRODUCTS['products-migration']}</Link>,
				icon: null,
			},
			{
				key: 'products-migration-admin',
				label: <Link to="/v2/admin-migration">{LABEL_MENU.PRODUCTS['products-migration-admin']}</Link>,
				icon: null,
			},
			{
				key: 'products-stock-admin',
				label: <Link to="/v2/admin-stock">{LABEL_MENU.PRODUCTS['products-stock-admin']}</Link>,
				icon: null,
			},
			{
				key: 'products-stock',
				label: <Link to="/v2/stock">{LABEL_MENU.PRODUCTS['products-stock']}</Link>,
				icon: null,
			},
		],
	},

	{
		key: 'payments-main',
		label: LABEL_MENU.PAYMENTS['payments-main'],
		icon: null,
		children: [
			{
				key: 'payments-token',
				label: <Link to="/v2/payments/token-pto-pago">{LABEL_MENU.PAYMENTS['payments-token']}</Link>,
				icon: null,
			},
			{
				key: 'payments-pos',
				label: <Link to="/v2/payments/resendPos">{LABEL_MENU.PAYMENTS['payments-pos']}</Link>,
				icon: null,
			},
		],
	},
	{
		key: 'configuration-main',
		label: LABEL_MENU.CONFIGURATION['configuration-main'],
		icon: null,
		children: [
			{
				key: 'configuration-users-management-admin',
				label: <Link to="/v2/admin-user-management">{LABEL_MENU.CONFIGURATION['configuration-users-management-admin']}</Link>,
				icon: null,
			},
			{
				key: 'configuration-users-management',
				label: <Link to="/v2/user-management">{LABEL_MENU.CONFIGURATION['configuration-users-management']}</Link>,
				icon: null,
			},
			{
				key: 'configuration-slider-admin',
				label: <Link to="/v2/admin-pharmacy-sliders">{LABEL_MENU.CONFIGURATION['configuration-slider-admin']}</Link>,
				icon: null,
			},
			{
				key: 'configuration-slider',
				label: <Link to="/v2/pharmacy-sliders">{LABEL_MENU.CONFIGURATION['configuration-slider']}</Link>,
				icon: null,
			},
			{
				key: 'configuration-landing-admin',
				label: <Link to="/landing">{LABEL_MENU.CONFIGURATION['configuration-landing-admin']}</Link>,
				icon: null,
			},
			{
				key: 'configuration-landing',
				label: <Link to="/user-landing">{LABEL_MENU.CONFIGURATION['configuration-landing']}</Link>,
				icon: null,
			},
			{
				key: 'configuration-icons-admin',
				label: <Link to="/v2/admin-pharmacy-icons/">{LABEL_MENU.CONFIGURATION['configuration-icons-admin']}</Link>,
				icon: null,
			},
			{
				key: 'configuration-icons',
				label: <Link to="/v2/pharmacy-icons/">{LABEL_MENU.CONFIGURATION['configuration-icons']}</Link>,
				icon: null,
			},
			{
				key: 'configuration-carousel-admin',
				label: <Link to="/admin-carousel">{LABEL_MENU.CONFIGURATION['configuration-carousel-admin']}</Link>,
				icon: null,
			},
			{
				key: 'configuration-carousel',
				label: <Link to="/carousel">{LABEL_MENU.CONFIGURATION['configuration-carousel']}</Link>,
				icon: null,
			},
			// {
			// 	key: 'configuration-users',
			// 	label: LABEL_MENU.CONFIGURATION['configuration-users'],
			// 	icon: null,
			// 	children: [
			// 		{
			// 			key: 'configuration-users-add-rol',
			// 			label: <Link to="/v2/users/assign-role">{LABEL_MENU.CONFIGURATION['configuration-users-add-rol']}</Link>,
			// 			icon: null,
			// 		},
			// 		{
			// 			key: 'configuration-users-local',
			// 			label: <Link to="/v2/users/set-local">{LABEL_MENU.CONFIGURATION['configuration-users-local']}</Link>,
			// 			icon: null,
			// 		},
			// 		{
			// 			key: 'configuration-users-email',
			// 			label: <Link to="/v2/users/email">{LABEL_MENU.CONFIGURATION['configuration-users-email']}</Link>,
			// 			icon: null,
			// 		},
			// 		{
			// 			key: 'configuration-users-search',
			// 			label: <Link to="/v2/users/find">{LABEL_MENU.CONFIGURATION['configuration-users-search']}</Link>,
			// 			icon: null,
			// 		},
			// 	],
			// },
		],
	},

	...(isPanelModuleEnabled('qfCriterion')
		? [
				{
					key: 'recipe-history-main',
					label: LABEL_MENU.RECIPE_HISTORY['recipe-history-main'],
					icon: null,
					children: [
						{
							key: 'recipe-history-qf',
							label: (
								<Link to="/v2/qf-criterion/list">{LABEL_MENU.RECIPE_HISTORY['recipe-history-qf']}</Link>
							),
							icon: null,
						},
						{
							key: 'recipe-history-qf-admin',
							label: (
								<Link to="/v2/admin-qf-criterion/list">
									{LABEL_MENU.RECIPE_HISTORY['recipe-history-qf-admin']}
								</Link>
							),
							icon: null,
						},
					],
				},
		  ]
		: []),
];
